export default "__VITE_ASSET__4Rwq63gj__"